// extracted by mini-css-extract-plugin
export default {"news-container":"news-container_news-container__KJhEY"};